import { Injectable } from '@angular/core';
import { getEnvironment } from '../environment/environment';

@Injectable()
export class SettingsProvider {

  static api_url = '';

  static endpoints = {
    authExternal: 'api/auth/social-media',
    login: 'organizations/auth-user/login',
    register: 'organizations/auth-user/register',
    logout: 'organizations/auth-user/logout',
    account: 'organizations/auth-user/me',
  };

  constructor() {}

  static authRegister(): string {
    const environment = getEnvironment();
    return environment.apiUrl + SettingsProvider.endpoints.register;
  }

  static authLogin(): string {
    const environment = getEnvironment();
    return environment.apiUrl + SettingsProvider.endpoints.login;
  }

  static authExternal(): string {
    const environment = getEnvironment();
    return environment.apiUrl + SettingsProvider.endpoints.authExternal;
  }

  static authLogout(): string {
    const environment = getEnvironment();
    return environment.apiUrl + SettingsProvider.endpoints.logout;
  }

  static getAccount(): string {
    const environment = getEnvironment();
    return environment.apiUrl + SettingsProvider.endpoints.account;
  }

  static getUrl(url:string): string{
    const environment = getEnvironment();
    return environment.apiUrl + 'api/' + url;
  }

  static url(url:string): string{
    const environment = getEnvironment();
    return environment.apiUrl + url;
  }

  static urlVaucher(url:string): string{
    const environment = getEnvironment();
    return environment.vaucherUrl + url;
  }
  static urlNormal(url:string): string{
    const environment = getEnvironment();
    return environment.apiUrlNormal + url;
  }
}
